'use client';

import React, { useCallback } from 'react';
import {
    VKShareButton,
    TelegramShareButton,
} from 'next-share';
import IconButton from '@frontend/jetlend-web-ui/src/ui/inputs/IconButton/IconButton';
import { addToastSuccess } from '@frontend/jetlend-core/src/ducks/toasts';
import { useDispatch } from 'react-redux';
import { IAchievementItemApiModel } from '@app/models/features/course';
import { BUTTONS_PROPS } from '@app/components/SociaButtonsList/SocialButtonsList';

import styles from './achievementShareButtons.module.scss';

export type Props = Pick<IAchievementItemApiModel, 'referral_link' | 'referral_title' | 'icon'> & {
    /**
     * Функция, после вызова которого, закрывается модальное окно
     */
    onClose?: VoidFunction;
}

/**
* Компонент для отображение кнопок шаринга в соц. сетях
* И кнопки копирования в буфер отмена
*/
const AchievementShareButtons = (props: Props) => {
    const {
        onClose,
        icon,
        referral_link,
        referral_title,
    } = props;

    const dispatch = useDispatch();

    const didCopyUrl = useCallback(() => {
        navigator.clipboard.writeText(referral_link);
        dispatch(addToastSuccess('Ссылка скопирована'));
        onClose();
    }, [referral_link, onClose]);

    return (
        <>
            <VKShareButton
                url={referral_link}
                title={referral_title}
                image={icon}
            >
                <IconButton
                    icon={BUTTONS_PROPS[0].icon}
                    containerClassName={styles['icon-button']}
                    iconClassName={styles['share-icon']}
                    onClick={onClose}
                    margin="left"
                />
            </VKShareButton>
            <TelegramShareButton
                url={referral_link}
                title={referral_title}
            >
                <IconButton
                    icon={BUTTONS_PROPS[1].icon}
                    containerClassName={styles['icon-button']}
                    iconClassName={styles['share-icon']}
                    onClick={onClose}
                    margin="left"
                />
            </TelegramShareButton>
            <IconButton
                icon={BUTTONS_PROPS[2].icon}
                containerClassName={styles['icon-button']}
                iconClassName={styles['share-icon']}
                onClick={didCopyUrl}
                margin="left"
            />
        </>
    );
};

export default AchievementShareButtons;
